<template>
  <Modal :id="id" :hide-header="true">
    <div slot="body" class="modal-body">
      <Alert v-if="!!alert" :alert="alert" />
    </div>
  </Modal>
</template>

<script>
import ModalMixin from "../../mixins/Modal";
export default {
  mixins: [ModalMixin],
  data() {
    return {
      id: "alert-modal",
      alert: null,
    };
  },
  mounted() {
    this.alert = this.options.alert || null;
  },
};
</script>